import React from 'react'
import './lily-loading.css'

const LilyLoading = () => {
    return (
        <div class="loadingio-spinner-spinner-nq4q5u6dq7r"><div class="ldio-x2uulkbinbj">
            <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
        </div></div>
    )
}

export default LilyLoading